// extracted by mini-css-extract-plugin
export var col = "content-module--col--3ebb9";
export var content = "content-module--content--6d107";
export var icon = "content-module--icon--46203";
export var item = "content-module--item--4df1d";
export var row = "content-module--row--d0ee2";